import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { deDE } from '@clerk/localizations';
import './index.css';
import App from './App';
import getClerkKey from './getClerkKey';
// Get Clerk publishable key from environment variable
const clerkPubKey = getClerkKey()

if (!clerkPubKey) {
  console.error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable');
}

// Customize German localization with app-specific text
const germanLocalization = {
  ...deDE,
  signIn: {
    ...deDE.signIn,
    start: {
      ...deDE.signIn?.start,
      title: 'Bei Eddy anmelden',
      subtitle: 'Willkommen zurück! Bitte melde dich an, um fortzufahren',
    },
    accountSwitcher: {
      ...deDE.signIn?.accountSwitcher,
    },
  },
  // Sign-up continue screen translations (for invitation flow)
  signUp: {
    ...deDE.signUp,
    continue: {
      ...deDE.signUp?.continue,
      title: 'Passwort erstellen',
      subtitle: 'Bitte legen Sie jetzt Ihr Passwort fest',
    },
  },
  // Add translations for invitation/accept invitation screens
  userProfile: {
    ...deDE.userProfile,
  },
  // Ensure all form fields and buttons are translated
  formFieldLabel__password: 'Passwort',
  formButtonPrimary__continue: 'Fortfahren',
  formFieldInputPlaceholder__password: 'Passwort eingeben',
  // Form validation error messages
  formFieldError__required: 'Bitte füllen Sie dieses Feld aus.',
  formFieldError__matching_passwords: 'Die Passwörter stimmen nicht überein.',
  formFieldError__email_invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  formFieldError__password_too_short: 'Das Passwort ist zu kurz.',
  // Additional text that might appear on invitation screens
  footerActionLink__signIn: 'Anmelden',
  footerActionText__signIn: 'Bereits ein Konto?',
  // Invitation screen translations
  userButton: {
    ...deDE.userButton,
  },
  // Organization invitation translations
  organizationInvitation: {
    ...deDE.organizationInvitation,
  },
  // Additional common form translations
  formFieldLabel__emailAddress: 'E-Mail-Adresse',
  formFieldLabel__firstName: 'Vorname',
  formFieldLabel__lastName: 'Nachname',
  formFieldLabel__username: 'Benutzername',
  // Top-level keys that might be used for missing fields screen
  formFieldLabel__missingFields: 'Passwort erstellen',
  formFieldDescription__missingFields: 'Bitte legen Sie jetzt Ihr Passwort fest',
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProvider 
        publishableKey={clerkPubKey}
        localization={germanLocalization}
        locale="de-DE"
        appearance={{
          variables: {
            colorPrimary: '#f97316', // Orange color to match your theme
          },
        }}
      >
        <App />
      </ClerkProvider>
    </BrowserRouter>
  </React.StrictMode>
);
